import Global from '../../store/global-selectors';
import * as Builders from '../../store/csw/csw.request-builders';

export const createRateComparisonMetadata = (state, fulfillmentPlanId) => {
  const sellerId = Global.selectSellerSellerId(state);
  const originalShippingConfiguration = Builders.buildSaveShippingConfigurationAndRateRequest(state, {
    fulfillmentPlanId,
  });

  return {
    sellerId,
    originalShippingConfiguration,
  };
};
